import { Routes } from '@angular/router';
import { AddressService } from '../@support';

export const routes: Routes = [
    {
        path: 'welcome/:addressToken',
        loadComponent: () => import('./pages/address/address.component').then(m => m.AddressComponent),
        resolve: { data: AddressService },
    },
    {
        path: 'ai-collection',
        loadComponent: () => import('./pages/payment/payment.component').then(m => m.PaymentComponent),
    },
    {
        path: 'cart',
        loadComponent: () => import('./pages/cart/cart.component').then(m => m.CartComponent),
    },
    {
        path: 'page-expired',
        loadComponent: () => import('./pages/page-expired/page-expired.component').then(m => m.PageExpiredComponent),
    },
    {
        path: '**',
        loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
    },
];
